import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
      position: 'top' ,
    },
    title: {
      display: true,
      text: 'Weekday, at which you are most likely going to fight',
    },
  },
  scales: {
    x: {
      grid: {
        display: false, // Hides vertical grid lines
      },
    },
    y: {
      grid: {
        display: false, // Hides horizontal grid lines
      },
    },
  },
};


export const data = {
  datasets: [
    {
      label: 'Dataset 1',
      data: [10, 20],
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
    },
  
  ],
};

export function Chart(props) {
  return(
    <div style={{minHeight:"500px", backgroundColor:"#faf8f8"}}>
      <Bar
          options={options}
          data={props.data} 
      />
    </div>
  )
}

export default Chart;
